// extracted by mini-css-extract-plugin
export default {"remove":"SurveyBranchingEditor_remove__j8f49","questionsReference":"SurveyBranchingEditor_questionsReference__0CGFM","scroll":"SurveyBranchingEditor_scroll__h4ea1"};